import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/ui/table";
import { useBusinessCentralMatchOneToOneListQuery } from "@/services/backend/business-central/api/match-one-to-one-api";
import t from "@/lang/lang";
import { TableLoadingRow } from "@/shared/components/tables/table-loading-row";
import { TableRtkErrorRow } from "@/shared/components/tables/table-rtk-error-row";
import { TableEmptyRow } from "@/shared/components/tables/table-empty-row";
import { MatchOneToOne } from "@/services/backend/business-central/types/match";
import { MatchType } from "@/services/backend/business-central/types/match-type";
import { CompanyName } from "@/services/backend/company/components/company-name";
import { BusinessCentralCompanyName } from "@/services/backend/business-central/components/business-central-company-name";
import { MatchOneToOneDeleteDialog } from "@/services/backend/business-central/components/match-one-to-one-delete-dialog";
import { BusinessCentralGesecResourceName } from "./business-central-gesec-resource-name";
import { MatchOneToOneProps } from "./match-one-to-one-props";

export function MatchOneToOneTable(props: MatchOneToOneProps) {
  const { data, isLoading, error } = useBusinessCentralMatchOneToOneListQuery({
    type: { active: true, values: [props.type] },
  });

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>{t("Type")}</TableHead>
          <TableHead>{t("GSM ID")}</TableHead>
          <TableHead>{t("Business Central ID")}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {isLoading && <TableLoadingRow colSpan={3} />}
        {error && <TableRtkErrorRow error={error} colSpan={3} />}
        {data?.items.length === 0 && !isLoading && !error && (
          <TableEmptyRow colSpan={3} />
        )}
        {data?.items.map((match) => (
          <TableRow key={`${match.type}-${match.gsmId}`}>
            <TableCell>{match.type}</TableCell>
            <TableCell>
              <GsmIdToName match={match} />
              <div>({match.gsmId})</div>
            </TableCell>
            <TableCell>
              <BcIdToName bcId={match.bcId} {...props} />
              <div>({match.bcId})</div>
            </TableCell>
            <TableCell>
              <MatchOneToOneDeleteDialog type={match.type} id={match.gsmId} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

function GsmIdToName({ match }: { match: MatchOneToOne }) {
  switch (match.type) {
    case MatchType.CompanyToCompany:
      return <CompanyName companyId={match.gsmId} />;
    case MatchType.ServiceKindToResource:
      return match.gsmId;
    default:
      return null;
  }
}

function BcIdToName({
  type,
  bcId,
  bcCompanyId,
}: { bcId: string } & MatchOneToOneProps) {
  switch (type) {
    case MatchType.CompanyToCompany:
      return <BusinessCentralCompanyName companyId={bcId} />;
    case MatchType.ServiceKindToResource:
      return (
        <BusinessCentralGesecResourceName bcCompanyId={bcCompanyId} no={bcId} />
      );
    default:
      return null;
  }
}
